import { takeEvery, takeLatest } from 'redux-saga/effects';
import { TELEMETRY_MODULE } from '../../../configs/moduleNames';
import {
  LOAD_VEHICLES_LIST,
  CREATE_VEHICLES,
  DELETE_VEHICLES,
  EDIT_VEHICLES_BY_ID,
  LOAD_VEHICLES_BY_ID,
  LOAD_TELEMETRY_LIST_ALL,
} from '../actions';

import loadTelemetryList from './loadTelemetryList';
import createTelemetry from './createTelemetry';
import loadTelemetryById from './loadTelemetryById';
import editTelemetryById from './editTelemetryById';
import deleteTelemetry from './deleteTelemetry';
import loadTelemetryListAll from './loadTelemetryListAll';

export default function* watchDashboard() {
  yield takeLatest(TELEMETRY_MODULE + LOAD_VEHICLES_LIST, loadTelemetryList);
  yield takeLatest(TELEMETRY_MODULE + LOAD_TELEMETRY_LIST_ALL, loadTelemetryListAll);
  yield takeLatest(TELEMETRY_MODULE + CREATE_VEHICLES, createTelemetry);
  yield takeEvery(TELEMETRY_MODULE + LOAD_VEHICLES_BY_ID, loadTelemetryById);
  yield takeEvery(TELEMETRY_MODULE + EDIT_VEHICLES_BY_ID, editTelemetryById);
  yield takeEvery(TELEMETRY_MODULE + DELETE_VEHICLES, deleteTelemetry);
}
